<script lang="ts">
  import Header from './partials/Header.svelte';
  import MergeSection from './partials/MergeSection.svelte';
  import type { ProfileMergeListOption } from '$shared/components/types';
  import type ProfileMergeListSection from '$provider/models/ProfileMergeListSection';

  interface Props {
    list?: ProfileMergeListSection[];
    option: ProfileMergeListOption;
    onalert?: (payload: any) => void;
    onreview?: (payload: any) => void;
    ontoggleadd?: (payload: any) => void;
    onresolveedit?: (payload: any) => void;
    onclickrecord?: (payload: any) => void;
    onaddall?: (payload: ProfileMergeListSection) => void;
    onignoreall?: (payload: ProfileMergeListSection) => void;
  }

  let { list = [], option, onalert, onreview, ontoggleadd, onresolveedit, onclickrecord, onaddall, onignoreall }: Props = $props();
</script>

<div data-cy="merge-list" class="comp-profile-merge-list">
  <Header {option} />
  <div class="content">
    {#each list as item}
      {#if !item.isListEmpty}
        <MergeSection
          {item}
          {onalert}
          {onreview}
          {ontoggleadd}
          {onresolveedit}
          {onclickrecord}
          {onaddall}
          {onignoreall}
        />
      {/if}
    {:else}
      <div data-cy="empty-merge-list" class="invalid">No item</div>
    {/each}
  </div>
</div>
